import React from 'react';
import { Paper, RaisedButton, FlatButton, Snackbar, Dialog } from 'material-ui';
import Help from 'material-ui/svg-icons/action/help';
import { Field, reduxForm } from 'redux-form';
import { loginUser, errorHandled, forgotPassword } from '../../../store/auth/actions';
import { connect } from 'react-redux';
import { Checkbox, TextField } from 'redux-form-material-ui';
import Footer from '../../../components/common/Footer/Footer';
import smartphoneIcon from '../../../resources/images/icons/smartphone.svg';
import Loading from '../../../components/common/Loading/Loading';
import styles from './LoginPage.css';
import '../../../resources/css/LoginPage.css';
import withTranslation from '../../../hoc/withTranslation';
import { HOMEPAGE } from '../../../constants/routes';

const form = reduxForm({ form: 'login' });

export class LoginPage extends React.Component {

    state = {
        loginError: null,
        passwordError: null,
        emailError: undefined,
        emailSentModalOpened: false,
        forgotPasswordModalOpened: false,
        forgotPasswordEmail: '',
    };

    componentWillMount() {
        if (this.props.authenticated) {
            if (this.props.previousPathname) {
                this.props.history.push(this.props.previousPathname);
            } else {
                this.props.history.push(HOMEPAGE);
            }
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.emailSent && this.props.isLoading && !nextProps.isLoading) {
            this.setState({
                emailSentModalOpened: true,
            });
        }

        if (nextProps.authenticated) {
            this.props.history.push(HOMEPAGE);
        }
    }

    // Actions

    handleFormSubmit = (formProps) => {
        if (formProps.login && formProps.password) {
            this
                .props
                .loginUser(formProps);
        } else {
            let newState = {
                loginError: null,
                passwordError: null,
            };
            if (!formProps.login) {
                newState.loginError = 'Mandatory field';
            }
            if (!formProps.password) {
                newState.passwordError = 'Mandatory field';
            }
            this.setState(newState);
        }
    };

    handleSnackbarClose = () => {
        this.props.errorHandled();
    };

    handleForgotPasswordEmailChange = (event) => {
        let email = event.target.value;
        let state = {
            forgotPasswordEmail: email,
        };

        if (email.length === 0) {
            state.emailError = 'Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            state.emailError = 'Invalid email address';
        } else {
            state.emailError = null;
        }

        this.setState(state);
    };

    handleOpenForgotPasswordModal = () => {
        this.setState({
            forgotPasswordModalOpened: true,
        });
    };

    handleCloseForgotPasswordModal = () => {
        this.setState({
            forgotPasswordModalOpened: false,
        });
    };

    handleForgotPassword = () => {
        this.props.forgotPassword(this.state.forgotPasswordEmail);
        this.handleCloseForgotPasswordModal();
    };

    handleCloseEmailModal = () => {
        this.setState({
            emailSentModalOpened: false,
        });
    };

    // Render

    renderContent() {
        let content;
        if (this.props.isLoading) {
            content = <Loading />;
        } else {
            content = <Paper style={styles.paper} disabled={true}>
                <form
                    onSubmit={this
                        .props
                        .handleSubmit(this.handleFormSubmit)}
                >

                    <Field
                        id="login"
                        name="login"
                        component={TextField}
                        type="text"
                        hintText={this.props.t('login.login')}
                        errorText={this.state.loginError}
                        floatingLabelText={this.props.t('login.login')}
                        fullWidth={true}
                    />

                    <Field
                        id="password"
                        name="password"
                        component={TextField}
                        type="password"
                        hintText={this.props.t('login.password')}
                        errorText={this.state.passwordError}
                        floatingLabelText={this.props.t('login.password')}
                        fullWidth={true}
                    />

                    <div>
                        <Field
                            id="rememberme"
                            name="rememberme"
                            component={Checkbox}
                            label={this.props.t('login.remember_me')}
                            style={styles.checkRemember.style}
                            labelStyle={styles.checkRemember.labelStyle}
                            iconStyle={styles.checkRemember.iconStyle}
                        />

                        <RaisedButton
                            type="submit"
                            label={this.props.t('login.login')}
                            primary={true}
                            disabled={this.props.isLoading}
                            style={styles.loginBtn}
                        />
                    </div>
                </form>
            </Paper>;
        }

        return content;
    }

    renderSnackbar() {
        return (
            <Snackbar
                open={this.props.authError !== null}
                message={this.props.authError || ''}
                action="Close"
                onActionTouchTap={this.handleSnackbarClose}
                onRequestClose={this.handleSnackbarClose}
            />
        );
    }

    renderForgotPasswordDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                disabled={this.props.isLoading}
                onClick={this.handleCloseForgotPasswordModal}
            />,
            <FlatButton
                label="Send"
                disabled={this.state.emailError !== null || this.props.isLoading}
                primary={true}
                onClick={this.handleForgotPassword}
            />,
        ];

        return (
            <Dialog
                title={this.props.t('login.forgotten_password')}
                actions={actions}
                modal={false}
                open={this.state.forgotPasswordModalOpened}
                onRequestClose={this.handleCloseForgotPasswordModal}
            >
                {this.props.isLoading && <Loading paper={false} />}
                {!this.props.isLoading &&
                    <div>
                        We will send you a new password to the following email
                        <br />
                        <br />
                        <TextField
                            hintText="Email"
                            errorText={this.state.emailError}
                            value={this.state.forgotPasswordEmail}
                            onChange={this.handleForgotPasswordEmailChange}
                        />
                    </div>
                }
            </Dialog>
        );
    }

    renderEmailSentDialog() {
        const actions = [
            <FlatButton
                label="OK"
                primary={true}
                onClick={this.handleCloseEmailModal}
            />,
        ];

        return (
            <Dialog
                title="Forgotten password"
                actions={actions}
                modal={false}
                open={this.state.emailSentModalOpened}
                onRequestClose={this.handleCloseEmailModal}
            >
                Email sent, please check your mailbox to get your new password.
            </Dialog>
        );
    }

    render() {
        return (
            <div>
                {this.renderSnackbar()}
                {this.renderForgotPasswordDialog()}
                {this.renderEmailSentDialog()}

                <div className="row center-xs" style={styles.loginHeader.row}>
                    <div
                        className="col-xs-10 col-sm-4 col-md-3 col-lg-3"
                        style={styles.loginHeader.titleContainer}
                    >
                        <span style={styles.loginHeader.title}>{this.props.t('login.title')}</span>
                        <br />
                        <br />
                        <span style={styles.loginHeader.desc}>
                            {this.props.t('login.subtitle')}
                        </span>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                        <img style={styles.loginHeader.image} src={smartphoneIcon} alt="logo" />
                    </div>
                </div>

                <div style={styles.loginContainer}>
                    {this.renderContent()}

                    <div style={styles.buttonsDiv}>
                        {/* <FlatButton
                            label="Register"
                            href="/"
                            style={styles.flatButton}
                            icon={< PersonAdd />}/> */}

                        <FlatButton
                            label={this.props.t('login.forgot_password')}
                            onClick={this.handleOpenForgotPasswordModal}
                            style={styles.flatButton}
                            icon={< Help />}
                        />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authError: state.auth.error,
        authenticated: state.auth.authenticated,
        isLoading: state.auth.pending,
        emailSent: state.auth.email,
        previousPathname: state.auth.previousPathname,
    };
}

export default connect(mapStateToProps,
    {
        forgotPassword,
        loginUser,
        errorHandled,
    },
)(
    form(withTranslation(LoginPage)));



// WEBPACK FOOTER //
// src/containers/common/LoginPage/LoginPage.js